import { render, staticRenderFns } from "./centre-list.vue?vue&type=template&id=0cc9cb88&scoped=true"
import script from "./centre-list.vue?vue&type=script&lang=js"
export * from "./centre-list.vue?vue&type=script&lang=js"
import style0 from "./centre-list.vue?vue&type=style&index=0&id=0cc9cb88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9cb88",
  null
  
)

export default component.exports